import { Injectable, Injector } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ConfigService } from '../config/config.service';
import { ICustomerAppsConfig } from '../config/config.module';
import { UserCredentialsStore } from './user-credentials-store.service';

@Injectable()
export class JWTTokenInterceptor implements HttpInterceptor {
  constructor(
    private userCredentialsStore: UserCredentialsStore,
    private configService: ConfigService<ICustomerAppsConfig>,
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const requestUrl = request.url;
    const normalizedRequestUrl = requestUrl.replace(/^\/app_dev\.php(.*)/, '$1');
    const isApiUrl =
      requestUrl.startsWith(this.configService.config.apiUrl) ||
      requestUrl.startsWith(this.configService.config.apiPath) ||
      normalizedRequestUrl.startsWith(this.configService.config.apiUrl) ||
      normalizedRequestUrl.startsWith(this.configService.config.apiPath) ||
      requestUrl.startsWith(this.configService.config.apiHost + '/apis/translation');

    if (isApiUrl && !request.headers.get('Authorization') && !requestUrl.match(/\/login/)) {
      const activeToken = this.userCredentialsStore.getAuthToken();
      request = request.clone({
        headers: request.headers.set('Authorization', `Bearer ${activeToken}`),
        withCredentials: false,
      });

      return next.handle(request).pipe(
        catchError((err: any) => {
          if (err instanceof HttpErrorResponse && err.status === 401) {
            this.userCredentialsStore.removeAuthToken();
          }

          return throwError(err);
        }),
      );
    }

    return next.handle(request);
  }
}
